export default {
    events: [],
    cityList:['Washington', 'New York'],
    selectedCity: null
  };


// WEBPACK FOOTER //
// ./src/reducers/initialState.js